import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/StockItemDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class StockItemEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItem"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItem/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItem/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItem/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItem/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItem/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItem/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

let stockItemTypeListEndPoint: IDataEndPoint = { url: app.config.controllerRouteRoot + "/stockItemType", method: "GET" },
		unitOfMeasureListEndPoint: IDataEndPoint = { url: app.config.controllerRouteRoot + "/unitOfMeasure", method: "GET" };

export class StockItemFormFields extends Array<IFieldOptions> {
	public unitOfMeasureName: IFieldOptions = { field: "unitOfMeasureName" };
	public id: IFieldOptions = { field: "id" };
	public stockItemTypeName: IFieldOptions = { field: "stockItemTypeName" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedById: IFieldOptions = { field: "changedById" };
	public unitOfMeasureId: IFieldOptions = { field: "unitOfMeasureId", dataEndPoint: unitOfMeasureListEndPoint, dataIdField: "id", dataDisplayField: "name" };
	public stockItemTypeId: IFieldOptions = { field: "stockItemTypeId", dataEndPoint: stockItemTypeListEndPoint, dataIdField: "id", dataDisplayField: "name" };
	public code: IFieldOptions = { field: "code" };
	public name: IFieldOptions = { field: "name" };
	public description: IFieldOptions = { field: "description" };
	public minOrderQuantity: IFieldOptions = { field: "minOrderQuantity" };
	public packagingQuantity: IFieldOptions = { field: "packagingQuantity" };
	public externalUrl: IFieldOptions = { field: "externalUrl" };
	public generalLedgerId: IFieldOptions = { field: "generalLedgerId" };
	public hierarchyId: IFieldOptions = { field: "hierarchyId" };
	public manufacturerModelNumber: IFieldOptions = { field: "manufacturerModelNumber" };
	constructor() {
		super();
		this.push(this.unitOfMeasureName);
		this.push(this.id);
		this.push(this.stockItemTypeName);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.unitOfMeasureId);
		this.push(this.stockItemTypeId);
		this.push(this.code);
		this.push(this.name);
		this.push(this.description);
		this.push(this.minOrderQuantity);
		this.push(this.packagingQuantity);
		this.push(this.externalUrl);
		this.push(this.generalLedgerId);
		this.push(this.hierarchyId);
		this.push(this.manufacturerModelNumber);
	}
}

export class StockItemForm implements IFormOptions {
	protected stockItemFormName: string = "stockItemForm";
	protected stockItemFormModel: models.StockItemDTO = new models.StockItemDTO();
	protected stockItemFormEndPoints: StockItemEndPoints = new StockItemEndPoints();
	protected stockItemFormFields: StockItemFormFields = new StockItemFormFields();
	public get name(): string { return this.stockItemFormName };
	public get model(): models.StockItemDTO { return this.stockItemFormModel };
	public get endPoints(): IEntityEndPoints { return this.stockItemFormEndPoints };
       public set endPoints(stockItemEndPoints: IEntityEndPoints) {
		this.stockItemFormEndPoints = stockItemEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): StockItemFormFields { return this.stockItemFormFields };
}

export class StockItemListColumns extends Array<IColumnOptions> {
	public unitOfMeasureName: IColumnOptions = { field: "unitOfMeasureName" };
	public id: IColumnOptions = { field: "id" };
	public stockItemTypeName: IColumnOptions = { field: "stockItemTypeName" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedById: IColumnOptions = { field: "changedById" };
	public unitOfMeasureId: IColumnOptions = { field: "unitOfMeasureId" };
	public stockItemTypeId: IColumnOptions = { field: "stockItemTypeId" };
	public code: IColumnOptions = { field: "code" };
	public name: IColumnOptions = { field: "name" };
	public description: IColumnOptions = { field: "description" };
	public minOrderQuantity: IColumnOptions = { field: "minOrderQuantity" };
	public packagingQuantity: IColumnOptions = { field: "packagingQuantity" };
	public externalUrl: IColumnOptions = { field: "externalUrl" };
	public generalLedgerId: IColumnOptions = { field: "generalLedgerId" };
	public hierarchyId: IColumnOptions = { field: "hierarchyId" };
	public manufacturerModelNumber: IColumnOptions = { field: "manufacturerModelNumber" };
	constructor() {
		super();
		this.push(this.unitOfMeasureName);
		this.push(this.id);
		this.push(this.stockItemTypeName);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.unitOfMeasureId);
		this.push(this.stockItemTypeId);
		this.push(this.code);
		this.push(this.name);
		this.push(this.description);
		this.push(this.minOrderQuantity);
		this.push(this.packagingQuantity);
		this.push(this.externalUrl);
		this.push(this.generalLedgerId);
		this.push(this.hierarchyId);
		this.push(this.manufacturerModelNumber);
	}
}

export class StockItemList implements IGridOptions {
	protected stockItemListName: string = "stockItemList";
	protected stockItemListModel: models.StockItemDTO = new models.StockItemDTO();
	protected stockItemListEndPoints: StockItemEndPoints = new StockItemEndPoints();
	protected stockItemListColumns: StockItemListColumns = new StockItemListColumns();
	public stockItemForm: StockItemForm = new StockItemForm();
	public get name(): string { return this.stockItemListName };
	public get model(): models.StockItemDTO { return this.stockItemListModel };
	public get endPoints(): IEntityEndPoints { return this.stockItemListEndPoints };
	public set endPoints(stockItemEndPoints: IEntityEndPoints) {
		this.stockItemListEndPoints = stockItemEndPoints;
		this.stockItemForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): StockItemListColumns { return this.stockItemListColumns };
}

export class StockItemEntity implements IEntityOptions {
	protected stockItemEntityName: string = "stockItemEntity";
	protected stockItemEntityModel: models.StockItemDTO = new models.StockItemDTO();
	protected stockItemEntityEndPoints: StockItemEndPoints = new StockItemEndPoints();
	protected stockItemEntityList: StockItemList = new StockItemList();
	public get name(): string { return this.stockItemEntityName };
	public get model(): models.StockItemDTO { return this.stockItemEntityModel };
	public get endPoints(): IEntityEndPoints { return this.stockItemEntityEndPoints };
	public set endPoints(stockItemEndPoints: IEntityEndPoints) {
		this.stockItemEntityEndPoints = stockItemEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): StockItemList { return this.stockItemEntityList };
	public get form(): StockItemForm { return this.grid.stockItemForm };
	constructor(name?: string) {
		if (name) this.stockItemEntityName = name;
		this.endPoints = this.stockItemEntityEndPoints;
	}
};
//export class StockItemGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: StockItemForm = new StockItemForm();
//};

//export class StockItemListPageComponent extends ListPageComponent {
  //protected listPageComponentList: StockItemList = new  StockItemList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class StockItemBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: StockItemGeneratedForm}];
//};

//export class StockItemListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: StockItemListPageComponent, isMenuHidden: true }];
//};

